<template>
    <div>
        <div >
            <p class="text-blue-600">Pending Approvals</p>
            <div class="flex">
                <p class="text-xs">{{pendingApprovals}} Carriers waiting to be approved</p>
                <router-link class="text-blue-600 text-xs ml-10" to="/pending-riders">see all<i class="fa fa-angle-right ml-2"></i></router-link>
            </div>
        <div class="flex mt-2">
            <p class="text-xs">{{pendingDsos}} Dsos waiting to be approved</p>
            <router-link class="text-blue-600 text-xs ml-10" to="/pending-dso">see all<i class="fa fa-angle-right ml-2"></i></router-link>
        </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['pendingApprovals', 'pendingDsos']
}
</script>